module.exports = __webpack_public_path__ + "img/h2.8f3b8d52.jpg";